import { FormControl, FormGroup } from '@angular/forms';
import { SaveViewModel } from '../save-view-model.model';
import { RegistrationSelfIdentification } from '../registration-self-identification.model';
import { RegistrationGender } from '../registration-gender.model';

export class RegistrationContactInfoExtension {
  fullName: string;
  addressLine: string;
  preferredLanguageDBID?: number; // For when validating a new member that was typed in and using it for badge.
  roleEnglishDescription: string; // For when validating a new member that was typed in and using it for badge.
  roleFrenchDescription: string; // For when validating a new member that was typed in and using it for badge.
  registrationSelfIdentificationSaveModel: SaveViewModel<RegistrationSelfIdentification>
  registrationGenderSaveModel: SaveViewModel<RegistrationGender>

  /**
   * Extend the default validation controls to set
   * @param form
   */
  static overrideDefaultForm(form: FormGroup) {
    form.addControl('localOrgNumber', new FormControl({ value: null }));
    form.addControl('fullName', new FormControl({ value: null, disabled: form.disabled }));
    form.addControl('addressLine', new FormControl({ value: null, disabled: form.disabled }));
  }
}
